<script>
  import { languagesStore } from "../store/languages.js";
  import { fade } from "svelte/transition";
  import { getContext } from "svelte";
  import Table from "../SharedComponents/Table.svelte";
  import Plus from "../Vectors/Plus.svelte";
  import * as util from "../js/util.js";
  import { link, navigate } from "svelte-routing";
  import LangDetail from "./LangDetail.svelte";

  const { open } = getContext("modal");

  let userId = "";

  function AddLanguage() {
    open(LangDetail, {
      callback: () => {
        languagesStore.getLangs();
      },
    });
  }

  function EditLanguage(row) {
    open(LangDetail, {
      lang: $languagesStore.langs.find((l) => l.id == row.id),
      callback: () => {
        languagesStore.getLangs();
      },
    });
  }

  languagesStore.getLangs();
  $: useLangs =
    $languagesStore.langs &&
    $languagesStore.langs.map((u) => {
      return {
        id: u.id,
        columns: {
          langName: u.langName,
          isRtl: u.isRtl ? "yes" : "no",
          culture: u.locale,
        },
      };
    });
</script>

<Table
  Title="Languages"
  bind:Items={useLangs}
  AddRowCallBack={AddLanguage}
  RowClickCallBack={EditLanguage}
/>
